import * as React from 'react';
import * as Cookies from "universal-cookie";
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { IUser, IPosition, ILogisticsResponse, ILogistics, IBaseResponse, ICenterNotification, IDonorWithMSRecipientUpdated, IImmunofreeCandidate, IWageAndTravelRequestWeek, IPhysicianLetterWeekUpload, IStrongBoxComplianceItem, IActionCenterCompliance, IBloodDrawConfirmationContract } from '@nkr/models/index';
import { OrganType } from '@nkr/enums/organ-type';
import {
    ActionCenterActionCreators, AppActionCreators, CenterNotificationActionCreators, DonorActionCreators, IActionCenterComplianceResponse, IActionCenterLookupDataResponse,
    IActionCenterOtherResponse, IActionCenterState, IActionCenterToDoResponse, IApplicationState, IAppState, ICenterNotificationListResponse, RecipientActionCreators, ReferralActionCreators,
    SwapActionCreators
} from '@nkr/store/index';
import { IActionCenterSettings, ISettings, MainType, sectionList } from './models/index';
import { ActionItem, InternalDirectAction } from '../models';
import { actionItemMap } from '../models/action-item-map';
import { refresh } from 'react-icons-kit/fa/refresh';
import { toast } from 'react-toastify';
import { gear } from 'react-icons-kit/fa/gear';
import { ButtonToolbar } from 'react-bootstrap';
import { InactiveDonorVerification, ConfirmDashDonations, MortalityRecipients, DonorWithRemotePatients, MicrositePendingApproval } from './lists';
import { ButtonWrapper, ContainerWrapper, IconWrapper } from './styles';
import ToDo from './to-do';
import Other from './other';
import ToDoList from './lists/to-do-list';
import OutstandingReimbursementRequests from './lists/outstanding-reimbursement-requests';
import Drawer from 'rc-drawer';
import Settings from './settings';
import Notifications from './notifications';
import Compliance from './compliance';
import PassMissingRecipientProfiles from './lists/pass-missing-recipient-profiles';
import StrongBoxToDoList from '@nkr/views/strong-box/data-compliance/strong-box-to-do';

interface IProps {
    centerId: number;
}

interface IStateProps {
    app: IAppState,
    actionCenter: IActionCenterState,
    user: IUser,
    notifications: ICenterNotification[],
    organType: OrganType
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getTodoItems: (centerId: number, liverOnly: boolean) => Promise<IActionCenterToDoResponse>,
    getOtherItems: (centerId: number, liverOnly: boolean) => Promise<IActionCenterOtherResponse>,
    getComplianceItems: (centerId: number, liverOnly: boolean) => Promise<IActionCenterComplianceResponse>,
    getCenterNotifications: (centerId: number) => Promise<ICenterNotificationListResponse>,
    getLogisticsData: (donorId: number, recipientId: number) => Promise<ILogisticsResponse>,
    getActionCenterLookupData: (centerId: number) => Promise<IActionCenterLookupDataResponse>,
    markNotificationRead: (id: number) => Promise<IBaseResponse>,
    updateReferralDisposition: (data: { id: number, disposition: string }[]) => Promise<IBaseResponse>,
    updateLostChainStarters: (updates: any[], deletes: number[]) => Promise<IBaseResponse>,
    confirmDashDonations: (list: { id: number, surgeryCompletedDateTime: string }[]) => Promise<IBaseResponse>,
    uploadFinalXm: (donorId: number, recipientId: number, acceptable: number, rootCause: string, correctiveAction: string, initials: string, finalXmFile: File) => Promise<IBaseResponse>,
    markInternalDirectDonated: (clusterId: number, donationDate: string) => Promise<IBaseResponse>,
    updateInternalDirectDonor: (donorId: number, donationDate: string) => Promise<IBaseResponse>
    updateWeekReimbursementRequestStatus: (centerId: number, list: IWageAndTravelRequestWeek[], physicianLetters?: IPhysicianLetterWeekUpload[]) => Promise<IBaseResponse>,
    updateDonorWithMSPatient: (updatedDonors: IDonorWithMSRecipientUpdated[]) => Promise<IBaseResponse>,
    inviteImmunoFreeCandidate: (centerId: number, candidate: IImmunofreeCandidate) => Promise<IBaseResponse>,
    updateDiabeticStatus: (data: { recipientId: number, isDiabetic: boolean }[]) => Promise<IBaseResponse>,
    setComplianceItems: (compliance: IActionCenterCompliance) => any,
    confirmBloodDraw: (contract: IBloodDrawConfirmationContract) => Promise<IBaseResponse>
    confirmBloodDrawCompletion: (contract: IBloodDrawConfirmationContract) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IProps;

interface IState {
    list: {
        show: boolean,
        type: ActionItem,
        items: any[],
        title: string,
        mainType: MainType
    },
    logistics: ILogistics | null,
    settings: ISettings,
    loading: {
        todo: boolean,
        other: boolean,
        compliance: boolean,
        notifications: boolean
    },
    originalList: any[]
}

class ActionCenterMain extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: {
            show: false,
            type: ActionItem.MatchOffers,
            items: [],
            title: '',
            mainType: MainType.ToDo
        },
        logistics: null,
        settings: {
            show: false,
            notifications: {
                hide: false,
                hideEmptyItems: false
            },
            todo: {
                hide: false,
                hideEmptyItems: false
            },
            other: {
                hide: false,
                hideEmptyItems: false
            },
            compliance: {
                hide: false,
                hideEmptyItems: false
            }
        },
        loading: {
            todo: true,
            other: true,
            compliance: true,
            notifications: true
        },
        originalList: []
    };

    container: HTMLDivElement;

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    };

    componentDidMount = () => {
        var cookies = new Cookies();
        var nkrActionCenter = cookies.get("nkr-action-center") as IActionCenterSettings;

        if (nkrActionCenter != null) {
            this.setState({
                settings: {
                    show: false,
                    ...nkrActionCenter
                }
            }, () => {
                this.getData();
            });
        } else {
            this.getData();
        }
    };

    getTodoItems = (): Promise<IActionCenterToDoResponse> => {
        return this.props.getTodoItems(this.props.centerId, this.props.organType == OrganType.Liver).then(response => {
            let loading = { ...this.state.loading, todo: false };

            this.setState({
                loading
            });

            return response;
        });
    }

    getOtherItems = () => {
        return this.props.getOtherItems(this.props.centerId, this.props.organType == OrganType.Liver).then(response => {
            let loading = { ...this.state.loading, other: false };

            this.setState({
                loading
            });

            return response;
        });
    }

    getComplianceItems = () => {
        return this.props.getComplianceItems(this.props.centerId, this.props.organType == OrganType.Liver).then(response => {
            let loading = { ...this.state.loading, compliance: false };

            this.setState({
                loading
            });

            return response;
        });
    }

    getNotifications = () => {
        return this.props.getCenterNotifications(this.props.centerId).then(response => {
            let loading = { ...this.state.loading, notifications: false };

            this.setState({
                loading
            });

            return response;
        });
    }

    getData = () => {
        this.setState({
            loading: {
                todo: true,
                other: true,
                compliance: true,
                notifications: true
            }
        }, () => {
            Promise.all([
                this.getTodoItems(),
                this.getOtherItems(),
                this.getComplianceItems(),
                this.getNotifications(),
                this.props.getActionCenterLookupData(this.props.centerId)
            ]);
        });
    };

    handleItemClick = (list: any[], mainType: MainType, subType: ActionItem) => {
        let mainItem = sectionList.find(x => x.id == mainType).desc;
        let subItem = actionItemMap(this.props.centerId).find(x => x.id == subType);

        if (subItem.useWindow) {
            this.setState({
                list: {
                    show: true,
                    type: subType,
                    items: list,
                    title: `${mainItem} - ${subItem.description}`,
                    mainType
                }
            });
        } else {
            if (subItem.separateTab) {
                window.open(subItem.location, '_blank');
            } else {
                window.location.href = subItem.location;
            }
        }
    };

    handleListClose = () => {
        this.setState({
            list: { ...this.state.list, show: false }
        });
    };

    handleMicrositesListClose = () => {
        this.setState({
            list: { ...this.state.list, show: false }
        }, () => {
            // this.props.getComplianceItems(this.props.centerId).then(() => { });
            this.getComplianceItems();
        });
    };


    handleMicrositePendApprovalListClose = () => {
        this.setState({
            list: { ...this.state.list, show: false }
        });
    };

    handleRefresh = () => {
        this.getData();
    };

    handleShowSideBar = () => {
        this.setState({
            settings: { ...this.state.settings, show: !this.state.settings.show }
        }, () => {
            if (!this.state.settings.show) {
                this.saveSettings();
            }
        });
    }

    handleShowHideSection = (section: string) => {
        let settings = { ...this.state.settings };
        settings[section].hide = !settings[section].hide;

        this.setState({
            settings
        });
    }

    handleShowHideEmpty = (section: string) => {
        let settings = { ...this.state.settings };
        settings[section].hideEmptyItems = !this.state.settings[section].hideEmptyItems;

        this.setState({
            settings
        });
    }

    handleGetLogistics = (swap: IPosition) => {
        return this.props.showLoading("Fetching logistics data, one moment please...").then(() => {
            return this.props.getLogisticsData(swap.donor.id, swap.recipient.id).then(response => {
                this.setState({
                    logistics: response.data.results
                }, () => {
                    this.props.hideLoading();
                });
            });
        });
    }

    handleChangeReferralDispositions = (data: { id: number, disposition: string }[]) => {
        this.setState({
            list: { ...this.state.list, show: false }
        }, () => {
            this.props.showLoading('Updating referral disposition, one moment please...').then(() => {
                this.props.updateReferralDisposition(data)
                    .then(response => {
                        if (response.data.success) {
                            this.getTodoItems().then(() => {
                                toast.success('Referral disposition updated successfully');
                            })
                        } else {
                            toast.error('Unable to update referral disposition');
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleUpdateDonorWithMSPatients = (updatedDonors: IDonorWithMSRecipientUpdated[]) => {
        this.setState({
            list: { ...this.state.list, show: true }
        }, () => {
            this.props.showLoading('Updating Donor record(s), one moment please...').then(() => {
                this.props.updateDonorWithMSPatient(updatedDonors)
                    .then(response => {
                        if (response.data.success) {
                            this.getComplianceItems().then(response => {
                                toast.success('Donor record updated successfully');
                            });
                        } else {
                            toast.error('Unable to update donor record');
                        }
                    })
                    .catch(error => {
                        toast.error(error?.response?.data?.message || "An unexpected error occurred while trying to update the donor");
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleIfCandidateInvite = (candidate: IImmunofreeCandidate) => {
        this.setState({
            list: { ...this.state.list, show: true }
        }, () => {
            this.props.showLoading('Updating record(s), one moment please...').then(() => {
                this.props.inviteImmunoFreeCandidate(this.props.centerId, candidate).then(response => {
                    if (response.data.success) {
                        this.setState({
                            list: { ...this.state.list, show: false }
                        });

                        toast.success('Invite Sent, updating list');

                        this.getTodoItems().then(() => {
                            this.props.hideLoading();
                        });
                    } else {
                        toast.error('Unable to update record');
                        this.props.hideLoading();
                    }
                });
            });
        });
    }

    handleUploadFinalXm = (donorId: number, recipientId: number, acceptable: number, rootCause: string, correctiveAction: string, initials: string, file: File) => {
        this.setState({
            list: { ...this.state.list, show: false },
        }, () => {
            this.props.showLoading('Saving FinalXM Results, one moment please...').then(() => {
                this.props.uploadFinalXm(donorId, recipientId, acceptable, rootCause, correctiveAction, initials, file)
                    .then(response => {
                        if (response.data.success) {
                            toast.success('Final XM Uploaded Successfully');

                            if (this.state.list.mainType == MainType.ToDo) {
                                this.getTodoItems();
                            }

                            if (this.state.list.mainType == MainType.Other || this.state.list.mainType == MainType.Compliance) {
                                this.getOtherItems();
                            }
                        } else {
                            toast.error('Could not upload the final XM');
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleUpdateLostChainStarters = (updates: Array<{ donorId: number, donationStartDate: string, donationEndDate: string }>, deletes: number[]) => {
        this.setState({
            list: { ...this.state.list, show: false }
        }, () => {
            this.props.showLoading('Updating donors, one moment please...').then(() => {
                this.props.updateLostChainStarters(updates, deletes)
                    .then(response => {
                        if (response.data.success) {
                            this.getOtherItems().then(() => {
                                toast.success('Inactive donors updated successfully');
                            });
                        } else {
                            toast.error('Unable to update inactive donors');
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleConfirmDashDonations = (list: { id: number, surgeryCompletedDateTime: string, confirmed: boolean }[]) => {
        this.setState({
            list: { ...this.state.list, show: false }
        }, () => {
            this.props.showLoading('Updating registrations, one moment please...').then(() => {
                this.props.confirmDashDonations(list)
                    .then(response => {
                        if (response.data.success) {
                            this.getOtherItems().then(() => {
                                toast.success('DASH registrations updated successfully');
                            });
                        } else {
                            toast.error('Unable to update DASH registrations');
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleMarkNotificationRead = (id: number) => {
        this.props.showLoading('One moment please...').then(() => {
            this.props.markNotificationRead(id).then(response => {
                if (response.data.success) {
                    this.getNotifications().then(centerResponse => {
                        this.props.hideLoading();
                    });
                } else {
                    this.props.hideLoading();
                }
            });
        });
    }

    handleUpdateInternalDirect = (id: number, donationDate: string, action: InternalDirectAction) => {
        this.setState({
            list: { ...this.state.list, show: false },
        }, () => {
            this.props.showLoading('Updating internal direct, one moment please...').then(() => {
                if (action == InternalDirectAction.ChangeDonationDate) {
                    this.props.updateInternalDirectDonor(id, donationDate).then(response => {
                        if (response.data.success) {
                            this.getTodoItems().then(() => {
                                this.props.hideLoading();
                                toast.success('Internal direct donor updated successfully');
                            });
                        } else {
                            this.props.hideLoading();
                            toast.error('Unable to update donation date.');
                        }
                    }).catch(error => {
                        this.props.hideLoading();
                        toast.error(typeof error?.response?.data == 'string' ? error.response.data : 'Unable to update donation date.');
                    });
                }

                if (action == InternalDirectAction.MarkCompleted) {
                    this.props.markInternalDirectDonated(id, donationDate).then(response => {
                        if (response.data.success) {
                            this.getTodoItems().then(() => {
                                this.props.hideLoading();
                                toast.success('Successfully changed internal direct to donated');
                            });
                        }
                    });
                }
            });
        });
    }

    handleUpdateWeekReimbursementRequestStatus = (
        list: IWageAndTravelRequestWeek[],
        physicianLetters?: IPhysicianLetterWeekUpload[],
        options?: { stayOpen?: boolean }
    ): Promise<void> => {
        return this.props.showLoading('Updating reimbursement status').then(() => {
            return this.props.updateWeekReimbursementRequestStatus(this.props.centerId, list, physicianLetters)
                .then(response => {
                    if (!response.data.success) {
                        toast.error(response.data.message);
                        return Promise.reject(new Error(response.data.message || 'Update failed'));
                    }
                    toast.success(response.data.message);
                    if (options?.stayOpen) {
                        return this.props.getTodoItems(this.props.centerId, this.props.organType == OrganType.Liver)
                            .then(todoResponse => {
                                const reimbursements = todoResponse.data.results.outstandingDonorReimbursements || [];
                                if (reimbursements.length === 0) {
                                    this.handleListClose();
                                } else {
                                    this.setState({
                                        list: { ...this.state.list, items: reimbursements }
                                    });
                                }
                            })
                            .finally(() => {
                                this.getData();
                            });
                    }
                    this.getData();
                    this.handleListClose();
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleUpdateDiabeticStatus = (data: { recipientId: number, isDiabetic: boolean }[], noRecordsLeft: boolean) => {
        this.props.showLoading('Updating diabetic status').then(() => {
            this.props.updateDiabeticStatus(data)
                .then(response => {
                    if (response.data.success) {
                        toast.success(response.data.message);

                        this.getData();

                        if (noRecordsLeft) {
                            this.setState({
                                list: { ...this.state.list, show: false }
                            });
                        }
                    } else {
                        toast.error(response.data.message);
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        })
    }

    handlePassMissingRecipientProfile = () => {
        this.setState({
            list: { ...this.state.list, show: false }
        });
    }

    handleStrongBoxItemResolved = (item: IStrongBoxComplianceItem) => {
        let compliance = _.cloneDeep(this.props.actionCenter.compliance);

        compliance.strongBoxComplianceList = compliance.strongBoxComplianceList.filter(x => x.type != item.type);

        this.props.setComplianceItems(compliance);

        var items = [...this.state.list.items];

        this.setState({
            list: { ...this.state.list, items: items.filter(f => f.type != item.type) }
        })
    }

    handleConfirmBloodDraw = (contract: IBloodDrawConfirmationContract) => {
        this.setState({
            list: { ...this.state.list, show: false }
        }, () => {
            this.props.showLoading('Confirming blood draw date, one moment please...').then(() => {
                this.props.confirmBloodDraw(contract)
                    .then(response => {
                        if (response.data.success) {
                            // Returned so finally() waits for the refresh - otherwise the overlay is hidden
                            // while the list is still loading and it updates a moment later on its own.
                            return this.getTodoItems().then(() => {
                                toast.success('Blood draw date confirmed successfully');
                            });
                        } else {
                            toast.error('Unable to confirm blood draw date');
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleConfirmBloodDrawCompletion = (contract: IBloodDrawConfirmationContract) => {
        this.setState({
            list: { ...this.state.list, show: false }
        }, () => {
            this.props.showLoading('Confirming blood draw, one moment please...').then(() => {
                this.props.confirmBloodDrawCompletion(contract)
                    .then(response => {
                        if (response.data.success) {
                            // Returned so finally() waits for the refresh - otherwise the overlay is hidden
                            // while the list is still loading and it updates a moment later on its own.
                            return this.getTodoItems().then(() => {
                                toast.success(contract.bloodDrawCompleted
                                    ? 'Blood draw completion confirmed successfully'
                                    : 'Blood draw rescheduled successfully');
                            });
                        } else {
                            toast.error('Unable to confirm blood draw');
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    saveSettings = () => {
        var cookies = new Cookies();
        let { todo, other, compliance } = this.state.settings

        cookies.set('nkr-action-center', { todo, other, compliance }, { path: "/", domain: __DOMAIN__, secure: __ISSECURE__, httpOnly: false });
    }

    getIsEmpty = () => {
        const { todo, other, compliance } = this.props.actionCenter;

        if (todo == null || other == null || compliance == null) {
            return { urgentIsEmpty: true, nonUrgentIsEmpty: true };
        }

        const todoIsEmpty =
            todo.matchOffers.length == 0
            && todo.donorClearance.length == 0
            && todo.preselectsOutstanding == 0
            && todo.requestsForDonorReview.length == 0
            && todo.xmResultsDueToday.length == 0
            && todo.confirmReimbursementDonations.length == 0
            && todo.missingVoucherHolders.length == 0
            && todo.customLogistics.length == 0
            && todo.pendingRccaps == 0
            && todo.inactiveDonorsInRange.length == 0
            && todo.donorEvalOutOfDate.length == 0
            && todo.pendingRecipientReferrals.length == 0
            && todo.pendingPatientIntakeReferrals.length == 0
            && todo.abWaitListPatients.length > 0 ? todo.abWaitListPatients[0].hasAbWaitListPatients == false && todo.abWaitListPatients[0].showHasAbWaitListPatients == false : false
            && todo.dashToDo.length == 0
            && todo.flaggedForVoucherDonation.length == 0
            && todo.outstandingInternalDirectSwaps.length == 0
            && todo.missingVoucherConsents.length == 0
            && todo.mortalityRecipients.length == 0
            && todo.outstandingDonorReimbursements.length == 0
            && todo.pendingPatientIntakeTransfers.length == 0;

        const otherIsEmpty = 
            other.logisticsKickoffCalls.length == 0
            && other.pickups.length == 0
            && other.deliveries.length == 0
            && other.pendingLogisticOptions == 0
            && other.lostChainStarters.length == 0
            && other.pendingReferrals.length == 0
            && other.wageAndTravelRequests.length == 0
            && other.voucherDonors.length == 0
            && other.finalXmResults.length == 0
            && other.donorEvalOutOfDate.length == 0
            && other.confirmDashDonations.length == 0
            && other.missingPostTransplantData.length == 0
            && other.missingCenterProfileData.length == 0
            && other.passMissingRecipientProfiles.length == 0;

        const complianceIsEmpty =
            compliance.activeRecipientsDataCompliance.length == 0
            && compliance.postTranplantRecipientsDataCompliance.length == 0
            && compliance.activeDonorsDataCompliance.length == 0
            && compliance.activeRdnDonorsDataCompliance.length == 0
            && compliance.postTranplantDonorsDataCompliance.length == 0
            && compliance.postTranplantRdnDonorsDataCompliance.length == 0
            && compliance.micrositeComplianceList.length == 0
            && compliance.donorsWithRemoteRecipient.length == 0
            && compliance.complianceWaitListAnatomyList.length == 0;

        return { todoIsEmpty, otherIsEmpty, complianceIsEmpty };
    }

    render = () => {
        const { todoIsEmpty, otherIsEmpty, complianceIsEmpty } = this.getIsEmpty();

        const notifications = this.props.notifications.filter(x => x.isRead == false && x.isEnabled);

        const toDoModalExclusionList = [
            ActionItem.AtRiskMortalityRecipients,
            ActionItem.OutstandingDonorReimbursements,
            ActionItem.PassMissingRecipientProfile,
            ActionItem.PackagingRemittance
        ]

        const todoSize = 12;
        const complianceSize = 6;
        const otherSize = 6;

        return (
            <>
                <div ref={this.saveContainer} />

                <ContainerWrapper className='container-fluid' style={{ paddingTop: 10 }}>
                    <div style={{ fontStyle: 'Roboto', fontSize: 16 }}>
                        {notifications.length > 0 && this.props.organType != OrganType.Liver && (
                            <div className='row'>
                                <div className={`col-xs-12 col-lg-12`}>
                                    <Notifications
                                        data={notifications}
                                        showLoading={this.state.loading.notifications}
                                        onMarkRead={this.handleMarkNotificationRead}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='row'>
                        {(!this.state.settings.todo.hide || todoIsEmpty == false) && (
                            <div className={`col-xs-12 col-lg-${todoSize}`}>
                                <ToDo
                                    data={this.props.actionCenter.todo}
                                    showLoading={this.state.loading.todo}
                                    hideEmptyItems={this.state.settings.todo.hideEmptyItems}
                                    isAdmin={false}
                                    organType={this.props.app.site.organType}
                                    onItemClick={this.handleItemClick}
                                />
                            </div>
                        )}

                        {(!this.state.settings.compliance.hide || complianceIsEmpty == false) && (
                            <div className={`col-xs-12 col-lg-${complianceSize}`} style={{ display: 'flex' }}>
                                <Compliance
                                    data={this.props.actionCenter.compliance}
                                    centerId={this.props.centerId}
                                    showLoading={this.state.loading.compliance}
                                    hideEmptyItems={this.state.settings.compliance.hideEmptyItems}
                                    organType={this.props.app.site.organType}
                                    onItemClick={this.handleItemClick}
                                />
                            </div>
                        )}

                        {(!this.state.settings.other.hide || otherIsEmpty == false) && (
                            <div className={`col-xs-12 col-lg-${otherSize}`} style={{ display: 'flex' }}>
                                <Other
                                    data={this.props.actionCenter.other}
                                    centerId={this.props.centerId}
                                    showLoading={this.state.loading.other}
                                    hideEmptyItems={this.state.settings.other.hideEmptyItems}
                                    organType={this.props.app.site.organType}
                                    onItemClick={this.handleItemClick}
                                />
                            </div>
                        )}
                    </div>

                    <div className='row'>
                        <div className='col-xs-12 text-right'>
                            <ButtonToolbar>
                                <ButtonWrapper bsStyle='link' style={{ float: 'right' }} onClick={this.handleRefresh}><IconWrapper icon={refresh} style={{ marginRight: 3, verticalAlign: 'middle' }} />Refresh</ButtonWrapper>
                                <ButtonWrapper bsStyle='link' style={{ float: 'right' }} onClick={this.handleShowSideBar}><IconWrapper icon={gear} style={{ marginRight: 3, verticalAlign: 'middle' }} />Settings</ButtonWrapper>
                            </ButtonToolbar>
                        </div>
                    </div>

                    <Drawer
                        width="20vw"
                        placement="right"
                        getContainer={this.getContainer}
                        open={this.state.settings.show}
                    >
                        <Settings
                            settings={this.state.settings}
                            inverted={false}
                            onShowSideBar={this.handleShowSideBar}
                            onShowHideSection={this.handleShowHideSection}
                            onShowHideEmpty={this.handleShowHideEmpty}
                        />
                    </Drawer>
                </ContainerWrapper>

                <ToDoList
                    show={this.state.list.show && !toDoModalExclusionList.includes(this.state.list.type)}
                    type={this.state.list.type}
                    title={this.state.list.title}
                    items={this.state.list.items}
                    logistics={this.state.logistics}
                    coordinators={this.props.actionCenter.lookupData.coordinatorList}
                    remoteStatus={this.props.actionCenter.lookupData.donorRemoteStatus}
                    centerId={this.props.centerId}
                    mainType={this.state.list.mainType}
                    onGetLogistics={this.handleGetLogistics}
                    onUploadFinalXm={this.handleUploadFinalXm}
                    onUpdateInternalDirect={this.handleUpdateInternalDirect}
                    onConfirmBloodDraw={this.handleConfirmBloodDraw}
                    onConfirmBloodDrawCompletion={this.handleConfirmBloodDrawCompletion}
                    onSave={this.handleUpdateDonorWithMSPatients}
                    onClose={this.handleListClose}
                />

                <InactiveDonorVerification
                    show={this.state.list.show && this.state.list.type == ActionItem.LostChainStarters}
                    items={this.state.list.items}
                    isAdmin={this.props.app.user.group.isSuper}
                    onUpdate={this.handleUpdateLostChainStarters}
                    onClose={this.handleListClose}
                />

                <ConfirmDashDonations
                    show={this.state.list.show && this.state.list.type == ActionItem.ConfirmDashDonations}
                    items={this.state.list.type == ActionItem.ConfirmDashDonations ? this.state.list.items : []}
                    onConfirm={this.handleConfirmDashDonations}
                    onClose={this.handleListClose}
                />

                <MortalityRecipients
                    show={this.state.list.show && this.state.list.type == ActionItem.AtRiskMortalityRecipients}
                    items={this.state.list.type == ActionItem.AtRiskMortalityRecipients ? this.state.list.items : []}
                    onClose={this.handleListClose}
                />

                <OutstandingReimbursementRequests
                    centerId={this.props.centerId}
                    show={this.state.list.show && this.state.list.type == ActionItem.OutstandingDonorReimbursements}
                    items={this.state.list.type == ActionItem.OutstandingDonorReimbursements ? this.state.list.items : []}
                    onSave={this.handleUpdateWeekReimbursementRequestStatus}
                    onClose={this.handleListClose}
                />

                <DonorWithRemotePatients
                    show={this.state.list.show && this.state.list.type == ActionItem.DonorsWithRemoteRecipient}
                    list={this.props.actionCenter.compliance != null ? this.props.actionCenter.compliance.donorsWithRemoteRecipient : []}
                    isAdmin={this.props.app.user.group.isSuper}
                    centerId={this.props.centerId}
                    statusList={this.props.actionCenter.lookupData.donorRemoteStatus}
                    coordinatorList={this.props.actionCenter.lookupData.coordinatorList}
                    onSave={this.handleUpdateDonorWithMSPatients}
                    onClose={this.handleMicrositesListClose}
                />

                <MicrositePendingApproval
                    show={this.state.list.show && this.state.list.type == ActionItem.MicrositePatientsPendingApproval}
                    list={this.props.actionCenter.other != null ? this.props.actionCenter.other.msPatientsPendingApproval : []}
                    centerId={this.props.centerId}
                    onClose={this.handleMicrositePendApprovalListClose}
                />

                <StrongBoxToDoList
                    show={this.state.list.show && this.state.list.type == ActionItem.StrongBoxDataCompliance}
                    title={this.state.list.title}
                    items={this.state.list.items}
                    isCenter={true}
                    onItemResolved={this.handleStrongBoxItemResolved}
                    onClose={this.handleListClose}
                />

                <PassMissingRecipientProfiles
                    show={this.state.list.show && this.state.list.type == ActionItem.PassMissingRecipientProfile}
                    items={this.props.actionCenter.other != null ? this.props.actionCenter.other.passMissingRecipientProfiles : []}
                    onClose={this.handlePassMissingRecipientProfile}
                />
            </>
        );
    };
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app,
        actionCenter: appState.actionCenter,
        user: appState.app.user,
        notifications: appState.centerNotifications.list,
        organType: appState.app.site.organType
    };
};

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: message => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getTodoItems: (centerId, liverOnly) => {
            return dispatch(ActionCenterActionCreators.getTodoItems(centerId, liverOnly));
        },
        getOtherItems: (centerId, liverOnly) => {
            return dispatch(ActionCenterActionCreators.getOtherItems(centerId, liverOnly));
        },
        getComplianceItems: (centerId, liverOnly) => {
            return dispatch(ActionCenterActionCreators.getComplianceItems(centerId, liverOnly));
        },
        getCenterNotifications: (centerId) => {
            return dispatch(CenterNotificationActionCreators.getCenterNotifications(centerId));
        },
        getLogisticsData: (donorId, recipientId) => {
            return dispatch(SwapActionCreators.getLogisticsDataByDonorRecipient(donorId, recipientId));
        },
        getActionCenterLookupData: (centerId) => {
            return dispatch(ActionCenterActionCreators.getLookupData(centerId));
        },
        markNotificationRead: (id) => {
            return dispatch(CenterNotificationActionCreators.markNotificationRead(id));
        },
        updateReferralDisposition: (data) => {
            return dispatch(ReferralActionCreators.updateReferralDisposition(data));
        },
        updateLostChainStarters: (updates, deletes) => {
            return dispatch(ActionCenterActionCreators.updateLostChainStarters(updates, deletes));
        },
        confirmDashDonations: (list) => {
            return dispatch(ActionCenterActionCreators.confirmDashDonations(list));
        },
        uploadFinalXm: (donorId, recipientId, acceptable, rootCause, correctiveAction, initials, finalXmFile) => {
            return dispatch(ActionCenterActionCreators.uploadFinalXm(donorId, recipientId, acceptable, rootCause, correctiveAction, initials, finalXmFile));
        },
        markInternalDirectDonated: (clusterId, donationDate) => {
            return dispatch(SwapActionCreators.markInternalDirectDonated(clusterId, donationDate));
        },
        updateInternalDirectDonor: (donorId, donationDate) => {
            return dispatch(DonorActionCreators.updateInternalDirectDonor(donorId, donationDate));
        },
        updateWeekReimbursementRequestStatus: (centerId, list, physicianLetters) => {
            return dispatch(ActionCenterActionCreators.updateWeekReimbursementRequestStatus(centerId, list, physicianLetters));
        },
        updateDonorWithMSPatient: (updatedDonors) => {
            return dispatch(DonorActionCreators.updateDonorWithMSPatient(updatedDonors));
        },
        inviteImmunoFreeCandidate: (centerId, candidate) => {
            return dispatch(ActionCenterActionCreators.inviteImmunoFreeCandidate(centerId, candidate));
        },
        updateDiabeticStatus: (data) => {
            return dispatch(RecipientActionCreators.updateDiabeticStatus(data));
        },
        setComplianceItems: (compliance) => {
            return dispatch(ActionCenterActionCreators.setComplianceItems(compliance));
        },
        confirmBloodDrawCompletion: (contract) => {
            return dispatch(ActionCenterActionCreators.confirmBloodDrawCompletion(contract));
        },
        confirmBloodDraw: (contract) => {
            return dispatch(ActionCenterActionCreators.confirmBloodDraw(contract));
        }
    };
};

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(ActionCenterMain);
